"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Desio certificazione contatti
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LottoApi = void 0;
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class LottoApi extends runtime.BaseAPI {
    /**
     *  (Auth roles: Admin)
     */
    apiLottoIdGetRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling apiLottoIdGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("Bearer", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/Lotto/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.LottoDtoFromJSON(jsonValue));
        });
    }
    /**
     *  (Auth roles: Admin)
     */
    apiLottoIdGet(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiLottoIdGetRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     *  (Auth roles: Admin)
     */
    apiLottoIdLottocertificazioniEsportaGetRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling apiLottoIdLottocertificazioniEsportaGet.');
            }
            const queryParameters = {};
            if (requestParameters.tipoEsportazioneCertificazioni !== undefined) {
                queryParameters['TipoEsportazioneCertificazioni'] = requestParameters.tipoEsportazioneCertificazioni;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("Bearer", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/Lotto/{id}/lottocertificazioni/esporta`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.BlobApiResponse(response);
        });
    }
    /**
     *  (Auth roles: Admin)
     */
    apiLottoIdLottocertificazioniEsportaGet(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiLottoIdLottocertificazioniEsportaGetRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     *  (Auth roles: Admin)
     */
    apiLottoIdLottocertificazioniGetRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling apiLottoIdLottocertificazioniGet.');
            }
            const queryParameters = {};
            if (requestParameters.pageSize !== undefined) {
                queryParameters['PageSize'] = requestParameters.pageSize;
            }
            if (requestParameters.pageNumber !== undefined) {
                queryParameters['PageNumber'] = requestParameters.pageNumber;
            }
            if (requestParameters.workflow !== undefined) {
                queryParameters['Workflow'] = requestParameters.workflow;
            }
            if (requestParameters.stato !== undefined) {
                queryParameters['Stato'] = requestParameters.stato;
            }
            if (requestParameters.nominativo !== undefined) {
                queryParameters['Nominativo'] = requestParameters.nominativo;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("Bearer", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/Lotto/{id}/lottocertificazioni`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.LottoCertificazioniDtoPagedListDtoFromJSON(jsonValue));
        });
    }
    /**
     *  (Auth roles: Admin)
     */
    apiLottoIdLottocertificazioniGet(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiLottoIdLottocertificazioniGetRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     *  (Auth roles: Admin)
     */
    apiLottoLottiGetRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("Bearer", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/Lotto/lotti`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.LottoSmallDtoFromJSON));
        });
    }
    /**
     *  (Auth roles: Admin)
     */
    apiLottoLottiGet() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiLottoLottiGetRaw();
            return yield response.value();
        });
    }
    /**
     *  (Auth roles: Admin)
     */
    apiLottoRicercaGetRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.dataInizio !== undefined) {
                queryParameters['DataInizio'] = requestParameters.dataInizio.toISOString();
            }
            if (requestParameters.dataFine !== undefined) {
                queryParameters['DataFine'] = requestParameters.dataFine.toISOString();
            }
            if (requestParameters.pageSize !== undefined) {
                queryParameters['PageSize'] = requestParameters.pageSize;
            }
            if (requestParameters.pageNumber !== undefined) {
                queryParameters['PageNumber'] = requestParameters.pageNumber;
            }
            if (requestParameters.nome !== undefined) {
                queryParameters['Nome'] = requestParameters.nome;
            }
            if (requestParameters.stato !== undefined) {
                queryParameters['Stato'] = requestParameters.stato;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("Bearer", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/Lotto/ricerca`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.DettaglioListLottoDtoPagedListDtoFromJSON(jsonValue));
        });
    }
    /**
     *  (Auth roles: Admin)
     */
    apiLottoRicercaGet(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiLottoRicercaGetRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiLottoUploadCsvPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("Bearer", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/Lotto/upload-csv`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.LottoCsvDtoToJSON(requestParameters.lottoCsvDto),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.LottoDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    apiLottoUploadCsvPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiLottoUploadCsvPostRaw(requestParameters);
            return yield response.value();
        });
    }
}
exports.LottoApi = LottoApi;
